<script lang="ts">
  import ChevronRightIcon from "@lucide/svelte/icons/chevron-right";
  import { cubicOut } from "svelte/easing";
  import { fly, slide } from "svelte/transition";

  type Link = { href: string; name: string };
  type LinkGroup = { hrefRoot: string; name: string; links: Link[] };

  type Props = {
    group: LinkGroup;
    onLinkClick: () => void;
    flyDelay?: number;
  };

  let { group, onLinkClick, flyDelay = 0 }: Props = $props();

  let isOpen = $state(false);
</script>

<div
  class="flex flex-col border-b border-divider px-9"
  transition:fly={{ y: -15, delay: flyDelay }}
>
  <button
    class="my-4 flex items-center justify-between text-primary"
    onclick={() => (isOpen = !isOpen)}
  >
    <span class="text-lg">{group.name}</span>
    <span
      class="icon-tertiary transition-transform duration-300 ease-out"
      style:transform={isOpen ? "rotate(90deg)" : "rotate(0deg)"}
    >
      <ChevronRightIcon size={24} />
    </span>
  </button>
  {#if isOpen}
    <div
      class="flex flex-col"
      transition:slide={{ easing: cubicOut, duration: 500 }}
    >
      {#each group.links as { href, name } (href)}
        <a
          class="mb-4 pl-6 text-secondary transition-colors hover:text-accent-hover"
          {href}
          onclick={onLinkClick}
        >
          {name}
        </a>
      {/each}
    </div>
  {/if}
</div>
